import {
  Box,
  ListItemButton,
  ListItemButtonProps,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import ArrowRightIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import { Link } from "react-router-dom";

type Props = {
  name?: string;
  count?: number;
  text: string;
  action: (id?: string) => void;
  link?: string;
  direction?: "row" | "column";
  ListItemButtonProps?: ListItemButtonProps;
  disabled?: boolean;
  selected?: boolean;
};

const QuickFilterButton = ({
  name,
  count,
  text,
  action,
  link,
  direction = "row",
  ListItemButtonProps = {},
  disabled,
  selected,
}: Props) => {
  const rowContent = (
    <>
      <Typography
        variant="header"
        fontSize="40px"
        fontWeight="700"
        minWidth="24px"
      >
        {count}
      </Typography>
      <ListItemText
        sx={{
          alignSelf: link ? "end" : "start",
          paddingBottom: "6px",
        }}
        primaryTypographyProps={{ whiteSpace: "wrap" }}
        primary={text}
      />
    </>
  );

  const columnContent = (
    <Box display="flex" flexDirection="column">
      {rowContent}
    </Box>
  );

  const borderWidth = selected ? "3px" : "1px";

  return (
    <ListItemButton
      {...(link && {
        component: Link,
        to: link,
      })}
      selected={selected}
      disabled={disabled}
      onClick={() => action(name)}
      disableRipple={!action}
      disableTouchRipple={!action}
      disableGutters
      sx={{
        padding: "1px 9px 1px 9px",
        margin: "16px 0px",
        gap: "8px",
        backgroundColor: "#4A1D9C0A",
        "&.Mui-selected": {
          backgroundColor: "#fff",
          "&:hover": {
            backgroundColor: "#fafafa",
          },
        },
        borderRadius: "8px",
        boxShadow: (theme) =>
          `inset 0 0 0 ${borderWidth} ${theme.palette.primary.light}`,
        width: "auto",
        maxWidth: "240px",
        minHeight: "64px",
        display: "flex",
        ...ListItemButtonProps.sx,
      }}
    >
      {direction === "row" ? rowContent : columnContent}
      {link && (
        <ListItemIcon sx={{ justifyContent: "end", minWidth: "0px" }}>
          <ArrowRightIcon
            sx={{
              color: (theme) => theme.palette.primary.light,
              fontSize: "1.8rem",
            }}
          />
        </ListItemIcon>
      )}
    </ListItemButton>
  );
};

export default QuickFilterButton;
